import React, { PureComponent } from 'react';

import { Message } from './Message';

export class NoAccess extends PureComponent {
  static displayName = NoAccess.name;

  render() {
    return (<Message messageContent="You have successfully logged in but have no access rights assigned yet." />);
  }
}